
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: { XHeader },
props: ['headerTitle','shareInfo','histroy',"isBackZcDetail",'isProvince'],
data() {
return {
show: false
}
},
methods: {
toShare() {
console.log(this.shareInfo)


var u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isiOS){
window.share.getShareDetailView(this.shareInfo);
}else{
window.android.getShareDetailView(this.shareInfo);
}


},
black(){
if(this.histroy){
if(localStorage.getItem("isProvince") == "true"){
this.$router.back(-1);
}else{
var u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isiOS){
window.webkit.messageHandlers.PopVCApp.postMessage('')
}else{
javascript: android.PopToApp('')
}
}
}else{
this.$router.back(-1);
}
}
},
mounted () {

}
}



// WEBPACK FOOTER //
// ./src/components/header/headerBackTitleShare.vue